import { render, staticRenderFns } from "./StudentIndex.vue?vue&type=template&id=bb841b6c&scoped=true"
import script from "./StudentIndex.vue?vue&type=script&lang=js"
export * from "./StudentIndex.vue?vue&type=script&lang=js"
import style0 from "./StudentIndex.vue?vue&type=style&index=0&id=bb841b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb841b6c",
  null
  
)

export default component.exports